import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Form,
  Spinner
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import {
  PDFNotaRemision as PDFOC,
  direccionDeCliente,
} from "./notaRemisionPDF";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from 'moment';

function ListadoVentas() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;

   let hoy = new Date()
    let inicio = new Date()
    inicio.setDate(inicio.getDate()-30);
   
    let endDate   = moment(hoy).format("YYYY-MM-DD"); 
    let startDate   = moment(inicio).format("YYYY-MM-DD");

const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [total_kilos_edit, setTotalKilosEdit] = useState(0);
  const [total_metros_edit, setTotalMetrosEdit] = useState(0);

  const [idEdit, setIdEdit] = useState("");
  const [articulosSurtidos, setArticulosSurtidos] = useState([]);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [validaBoton, setValidaBoton] = useState(true);
    const [modalProgreso, setModalProgreso] = useState(false);
    const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

    const [selectedImpuestos, setSelectedImpuestos] = useState("");
    const [selectedDuplicado, setSelectedDuplicado] = useState("");
    const [selectedSucursal, setSelectedSucursal] = useState("");
    const [sucursales, setSucursales] = useState([]);

  const [activo, setActivo] = useState("");
  // const [precio, setPrecio] = useState();

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
 axios
  .get(URL_SURTIDOS, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allSurtidos = response.data;

    // primero ordenamos
    let surtidosOrdenados = allSurtidos.sort((a, b) =>
      a.idSurtido < b.idSurtido ? 1 : -1
    );

    // contador de combinaciones repetidas
    const contadorDuplicados = {};

    surtidosOrdenados.forEach((a) => {
      const idPedido = a.pedidos?.[0]?.idPedido || "";
      const is_active = a.is_active || "";
      const nombreColaborador = a.nombreColaborador || "";
      const sucursalColaborador =
        typeof a.sucursalColaborador === "object"
          ? a.sucursalColaborador?.name || a.sucursalColaborador?._id || ""
          : a.sucursalColaborador || "";

      const key = `${is_active}__${idPedido}__${nombreColaborador}__${sucursalColaborador}`;
      contadorDuplicados[key] = (contadorDuplicados[key] || 0) + 1;
    });

    let arrayTabla = surtidosOrdenados
      .map((a) => {
        const idPedido = a.pedidos?.[0]?.idPedido || "";
        const is_active = a.is_active || "";
        const nombreColaborador = a.nombreColaborador || "";
        const sucursalColaboradorNormalizada =
          typeof a.sucursalColaborador === "object"
            ? a.sucursalColaborador?.name || a.sucursalColaborador?._id || ""
            : a.sucursalColaborador || "";

        const key = `${is_active}__${idPedido}__${nombreColaborador}__${sucursalColaboradorNormalizada}`;

        return {
          _id: a._id,
          is_active: a.is_active,
          fecha: a.fecha,
          user: a.user[0].nombre + " " + a.user[0].apellido,
          idUser: a.user[0]._id,
          idpedidos: a.pedidos[0].idPedido,
          pedidoCliente: a.pedidos[0].pedidoCliente,
          clientes: a.clientes[0].nombre_comercial,
          codigo: a.clientes[0].numero,
          idClientes: a.clientes[0]._id,
          observaciones: a.observaciones,
          numero: a.idSurtido,
          impuestos: a.impuestos,
          subTotal: a.subTotal,
          iva: a.iva,
          total_general: a.total_general,
          totalCantidad: a.totalCantidad,
          RFC: a.clientes[0].RFC,
          vendedor:
            a.pedidos[0].colaboradores[0].nombre +
            " " +
            a.pedidos[0].colaboradores[0].apellido,
          plazo: a.clientes[0].plazo,
          recibida: a.recibida,
          numeroFactura: a.numeroFactura,
          descuento: a.descuento,
          descuento2: a.descuento2,
          nombreColaborador: a.nombreColaborador,
          sucursalColaborador: a.sucursalColaborador,
          areaColaborador: a.areaColaborador,
          numeroColaborador: a.numeroColaborador,
          entregadoCon: a.entregadoCon,
          esVentaDirecta:
            a.esVentaDirecta || a.pedidos?.[0]?.esVentaDirecta || "No",
          alumno: a.alumno || a.pedidos?.[0]?.alumno || "",
          formaPago: a.formaPago || a.pedidos?.[0]?.formaPago || "",
          idPedido: a.pedidos?.[0]?.idPedido || "",
          duplicado: contadorDuplicados[key] > 1 ? "Si" : "No",
          // (2026-10) para la nota de remisión
          empresa: a.empresas?.[0]?.name || "",
          subCliente: a.pedidos?.[0]?.subCliente || "NA",
          telefonoCliente: a.clientes?.[0]?.telefono || "",
          direccionCliente: direccionDeCliente(a.clientes?.[0]),
        };
      })
      .filter((el) => el != null);

    let dataFinal = Object.values(arrayTabla);

    // 🔥 ARRAY DE SUCURSALES ÚNICAS
    const sucursales = [
      ...new Set(
        dataFinal
          .map((a) =>
            typeof a.sucursalColaborador === "object"
              ? a.sucursalColaborador?.name
              : a.sucursalColaborador
          )
          .filter(Boolean)
      ),
    ].map((s) => ({ name: s }));

    // States
    setSucursales(sucursales);
    setSurtidos(allSurtidos);
    setComments(dataFinal);
  })
  .catch((err) => {
    console.log(err);
  });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  let totalImportePDF = 0;
  let subTotalPDF = 0;
  let totalIVAPDF = 0;

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)&& 
        (selectedDuplicado == 0 || selectedDuplicado == a.duplicado) &&
        (selectedSucursal == 0 || selectedSucursal == a.sucursalColaborador)&&
        (
          (selectedImpuestos == "Si" && a.iva > 0) || // Si selecciona "Si", verificar si los impuestos son mayores o iguales a 0
          (selectedImpuestos == "No" && a.iva == 0) || // Si selecciona "No", verificar si los impuestos son exactamente 0
          selectedImpuestos == "" // Para la opción "Todos", no aplicar un filtro específico de impuestos
        )
      ) {
        if(a.is_active == "Si"){
        totalImportePDF = totalImportePDF + a.total_general;
        subTotalPDF = subTotalPDF + a.subTotal;
        totalIVAPDF = totalIVAPDF + a.iva;
        return [
          a.numero,
          a.numeroFactura,
          a.fecha,
          a.clientes,
          a.sucursalColaborador,
          a.nombreColaborador,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subTotal),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
          a.user,
        ]
      }else {
        return [
          a.numero,
          a.numeroFactura,
          a.fecha,
          a.clientes,
          a.sucursalColaborador,
          a.nombreColaborador,
          "",
          "Cancelada",
          "",
          a.user,
        ]
      }
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    doc.text(`Listado de Facturas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "No.",
          "Factura",
          "Fecha",
          "Cliente",
          "Sucursal",
          "Colaborador",
          "SubTotal",
          "IVA",
          "Total",
          "Surtio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(subTotalPDF),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalIVAPDF),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalImportePDF),
        ],
      ],
    });
    doc.save(`Facturas.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)&& // Asegurando que el elemento esté activo
        (selectedDuplicado == 0 || selectedDuplicado == a.duplicado) &&
        (selectedSucursal == 0 || selectedSucursal == a.sucursalColaborador)&&
        (
          (selectedImpuestos == "Si" && a.iva > 0) || // Si selecciona "Si", verificar si los impuestos son mayores o iguales a 0
          (selectedImpuestos == "No" && a.iva == 0) || // Si selecciona "No", verificar si los impuestos son exactamente 0
          selectedImpuestos == "" // Para la opción "Todos", no aplicar un filtro específico de impuestos
        )
      ) {
        if(a.is_active == "Si"){
        return {
          Numero: a.numero,
          Factura: a.numeroFactura,
          Fecha: a.fecha,
          Cliente: a.clientes,
          Sucursal: a.sucursalColaborador,
          Colaborador: a.nombreColaborador,
          SubTotal: a.subTotal,
          IVA: a.iva,
          Total: a.total_general,
          Surtio: a.user,
        }
        }else{
          return {
            Numero: a.numero,
            Factura: a.numeroFactura,
            Fecha: a.fecha,
            Cliente: a.clientes,
            Sucursal: a.sucursalColaborador,
            Colaborador: a.nombreColaborador,
            SubTotal: 0,
            IVA: 0,
            Total: 0,
            Surtio: a.user,
          }
        }
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoFacturas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoFacturas",
        sheetFilter: [
          "Numero",
          "Factura",
          "Fecha",
          "Cliente",
          "Sucursal",
          "Colaborador",
          "SubTotal",
          "IVA",
          "Total",
          "Surtio",
        ],
        sheetHeader: [
          "Numero",
          "Factura",
          "Fecha",
          "Cliente",
          "Sucursal",
          "Colaborador",
          "SubTotal",
          "IVA",
          "Total",
          "Surtio",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)&& // Asegurando que el elemento esté activo
        (selectedDuplicado == 0 || selectedDuplicado == a.duplicado) &&
        (
          (selectedImpuestos == "Si" && a.iva > 0) || // Si selecciona "Si", verificar si los impuestos son mayores o iguales a 0
          (selectedImpuestos == "No" && a.iva == 0) || // Si selecciona "No", verificar si los impuestos son exactamente 0
          selectedImpuestos == "" // Para la opción "Todos", no aplicar un filtro específico de impuestos
        )
      ) {
        return [a.numero, a.numeroFactura, a.fecha, a.clientes, a.pedidos, a.subTotal, a.iva, a.total_general, a.user];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    doc.text(`Listado de Facturas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Factura", "Fecha", "Cliente", "Pedido", "SubTotal", "IVA", "Total", "Surtio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    var att = doc.output("arraybuffer");
    var base64File = doc.output("datauristring").split(",")[1];

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Facturas",
          email: mailTo,
          fileName: "ListadoFacturas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Facturas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function cancelarNota(idNota) {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Escribe cancelar para confirmar la acción.",
      icon: "warning",
      input: "text",
      inputPlaceholder: "Escribe cancelar aquí",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
      preConfirm: (inputValue) => {
        if (inputValue !== "cancelar") {
          Swal.showValidationMessage("Debes escribir exactamente: cancelar");
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${URL_SURTIDOS}Cancel/${idNota}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            Swal.fire("Cancelado", "La nota ha sido cancelada", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Algo salió mal!",
              footer: `${error.response?.data || error.message}`,
            });
            console.log(error);
          });
      }
    });
  }
  
async function PDFTicket(
  fecha,
  idClientes,
  clientes,
  observaciones,
  numero,
  idPDFOC,
  user,
  pedidoCliente,
  impuestos,
  subTotal,
  iva,
  total_general,
  totalCantidad,
  plazo,
  numeroFactura,
  descuento,
  descuento2,
  nombreColaborador,
  sucursalColaborador,
  areaColaborador,
  numeroColaborador,
  entregadoCon,
  esVentaDirecta,
  alumno,
  formaPago,
  vendedor,
  idPedido
) {
  try {
    const { data: allArticulosSurtido } = await axios.get(
      `${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const safeText = (txt) => String(txt || "").trim();

    const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];

    const agrupado = {};

    allArticulosSurtido.forEach((a) => {
      // L118 (2026-06) — subDepartamento del artículo en vez de la descripción
      const articulo = `${a.articulos?.[0]?.codigo || ""} ${
        a.articulos?.[0]?.subDepartamentos?.[0]?.name ||
        a.articulos?.[0]?.descripcion ||
        a.articulos?.[0]?.nombre ||
        "Sin artículo"
      }`.trim();

      // Si es Venta Directa agrupamos por articulo + precio para que dos
      // ventas del mismo articulo con precios distintos salgan en renglones
      // separados. Para tickets normales seguimos agrupando solo por articulo.
      const esVDKey = String(esVentaDirecta || "").toLowerCase() === "si";
      const key = esVDKey
        ? `${articulo}||${Number(a.precio || 0).toFixed(2)}`
        : articulo;

      if (!agrupado[key]) {
        agrupado[key] = [];
        agrupado[key].articulo = articulo;
      }
      agrupado[key].push(a);
    });

    const esVD = String(esVentaDirecta || "").toLowerCase() === "si";

    const formaPagoLabelMap = {
      "01": "Efectivo",
      "02": "Cheque nominativo",
      "03": "Transferencia",
      "04": "Tarjeta de credito",
      "05": "Monedero electronico",
      "06": "Dinero electronico",
      "08": "Vales de despensa",
      "12": "Dacion en pago",
      "13": "Pago por subrogacion",
      "14": "Pago por consignacion",
      "15": "Condonacion",
      "17": "Compensacion",
      "23": "Novacion",
      "24": "Confusion",
      "25": "Remision de deuda",
      "26": "Prescripcion o caducidad",
      "27": "A satisfaccion del acreedor",
      "28": "Tarjeta de debito",
      "29": "Tarjeta de servicios",
      "30": "Aplicacion de anticipos",
      "31": "Intermediario pagos",
      "99": "Por definir",
    };
    const formaPagoTxt = (() => {
      const codeRaw = safeText(formaPago);
      if (!codeRaw || codeRaw.toUpperCase() === "NA") return "";
      const label = formaPagoLabelMap[codeRaw] || "";
      return label ? `(${codeRaw})${label}` : codeRaw;
    })();

    const numeroLetras = (() => {
      try {
        const n = Math.floor(Number(total_general) || 0);
        const c = Math.round(((Number(total_general) || 0) - n) * 100);
        const u = [
          "CERO","UNO","DOS","TRES","CUATRO","CINCO","SEIS","SIETE","OCHO","NUEVE","DIEZ",
          "ONCE","DOCE","TRECE","CATORCE","QUINCE","DIECISEIS","DIECISIETE","DIECIOCHO","DIECINUEVE","VEINTE",
        ];
        const dec = ["","","VEINTE","TREINTA","CUARENTA","CINCUENTA","SESENTA","SETENTA","OCHENTA","NOVENTA"];
        const cen = ["","CIENTO","DOSCIENTOS","TRESCIENTOS","CUATROCIENTOS","QUINIENTOS","SEISCIENTOS","SETECIENTOS","OCHOCIENTOS","NOVECIENTOS"];
        const sub999 = (x) => {
          if (x === 0) return "";
          if (x <= 20) return u[x];
          if (x < 100) {
            const d = Math.floor(x / 10);
            const r = x % 10;
            if (x < 30) return `VEINTI${u[r].toLowerCase()}`.toUpperCase();
            return r === 0 ? dec[d] : `${dec[d]} Y ${u[r]}`;
          }
          if (x === 100) return "CIEN";
          const c100 = Math.floor(x / 100);
          const r = x % 100;
          return r === 0 ? cen[c100] : `${cen[c100]} ${sub999(r)}`;
        };
        const enLetras = (x) => {
          if (x === 0) return "CERO";
          let result = "";
          const mil = Math.floor(x / 1000);
          const r = x % 1000;
          if (mil > 0) {
            result = mil === 1 ? "MIL" : `${sub999(mil)} MIL`;
          }
          if (r > 0) {
            result = result ? `${result} ${sub999(r)}` : sub999(r);
          }
          return result.trim();
        };
        const ent = enLetras(n);
        const cc = String(c).padStart(2, "0");
        return `${ent} PESOS ${cc}/100 M.N.`;
      } catch (_) {
        return "";
      }
    })();

    const fmt = (v) =>
      new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(v) || 0);

    // TK6 — preguntar si el ticket sale con precio
    const promptPrecioTicket = await Swal.fire({
      title: "¿El ticket sale con precio?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "No",
    });
    const mostrarPrecio = promptPrecioTicket.isConfirmed;

    const construirLineasTicket = () => {
      const lineas = [];

      lineas.push({ type: "logo" });

      if (esVD) {
        if (safeText(alumno)) {
          lineas.push({ type: "text", text: `Nombre: ${safeText(alumno)}` });
        }
        lineas.push({ type: "text", text: `Cliente: ${clientes}` });
        lineas.push({ type: "line" });
        if (safeText(sucursalColaborador)) {
          lineas.push({
            type: "text",
            text: `Tienda: ${safeText(sucursalColaborador)}`,
          });
        }
        lineas.push({
          type: "text",
          text: `Folio: ${String(idPedido || numero || "").padStart(10, "0")}`,
        });
        lineas.push({ type: "text", text: `Fecha: ${fecha}` });
        const horaStr = new Date().toLocaleTimeString("es-MX", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });
        lineas.push({ type: "text", text: `Hora: ${horaStr}` });
        lineas.push({
          type: "text",
          text: `Vendedor: ${safeText(vendedor || nombreColaborador)}`,
        });
        lineas.push({ type: "line" });
        lineas.push({ type: "tableHeader" });
        lineas.push({ type: "line" });
      } else {
        lineas.push({ type: "title", text: "TICKET" });
        lineas.push({ type: "line" });
        lineas.push({ type: "text", text: `Cliente: ${clientes}` });
        lineas.push({ type: "text", text: `Fecha: ${fecha}` });
        lineas.push({ type: "text", text: `Nota: ${numero}` });
        lineas.push({ type: "text", text: `Pedido: ${pedidoCliente}` });
        lineas.push({
          type: "text",
          text: `Colaborador: ${safeText(nombreColaborador)}`,
        });

        if (safeText(numeroColaborador)) {
          lineas.push({
            type: "text",
            text: `Número: ${safeText(numeroColaborador)}`,
          });
        }

        if (safeText(sucursalColaborador)) {
          lineas.push({
            type: "text",
            text: `Sucursal: ${safeText(sucursalColaborador)}`,
          });
        }

        if (safeText(areaColaborador)) {
          lineas.push({
            type: "text",
            text: `Area: ${safeText(areaColaborador)}`,
          });
        }

        if (safeText(entregadoCon)) {
          lineas.push({
            type: "text",
            text: `Entregado con: ${safeText(entregadoCon)}`,
          });
        }

        lineas.push({ type: "text", text: `Cantidad total: ${totalCantidad}` });
        lineas.push({ type: "line" });
      }

      if (esVD) {
        // ====== Formato Venta Directa: una línea por artículo+precio ======
        let totalPrendas = 0;
        for (const key in agrupado) {
          const grupo = agrupado[key];
          const articuloNombre = grupo.articulo || key.split("||")[0];
          let cantArticulo = 0;
          let importeArticulo = 0;
          let pu = 0;
          grupo.forEach((a) => {
            const c = Number(a.cantidad || 0);
            const p = Number(a.precio || 0);
            cantArticulo += c;
            importeArticulo += c * p;
            if (!pu && p) pu = p;
          });
          totalPrendas += cantArticulo;
          lineas.push({
            type: "tableRow",
            cant: cantArticulo,
            descripcion: articuloNombre,
            // TK6 — precio/importe solo si el ticket sale con precio
            pu: mostrarPrecio ? fmt(pu) : "",
            importe: mostrarPrecio ? fmt(importeArticulo) : "",
          });
        }

        lineas.push({ type: "line" });
        lineas.push({
          type: "textBold",
          text: `${totalPrendas} Prenda(s)`,
        });
        lineas.push({ type: "line" });
        // TK6 — montos solo si el ticket sale con precio
        if (mostrarPrecio) {
          lineas.push({
            type: "text",
            text: `SubTotal:                ${fmt(subTotal || total_general)}`,
          });
          lineas.push({
            type: "text",
            text: `Descuento:               ${fmt(descuento || 0)}`,
          });
          lineas.push({
            type: "text",
            text: `Impuesto:                ${fmt(iva || 0)}`,
          });
          lineas.push({ type: "line" });
          lineas.push({
            type: "textBold",
            text: `Total:                   ${fmt(total_general)}`,
          });
          lineas.push({ type: "line" });
        }

        if (formaPagoTxt) {
          lineas.push({ type: "text", text: `Forma de Pago: ${formaPagoTxt}` });
        }
        lineas.push({ type: "text", text: `Tipo de Venta: MOSTR` });
        lineas.push({ type: "line" });

        // TK6 — total en letra solo si el ticket sale con precio
        if (mostrarPrecio && numeroLetras) {
          lineas.push({ type: "textWrap", text: numeroLetras });
          lineas.push({ type: "line" });
        }

        if (observaciones && safeText(observaciones).toUpperCase() !== "NA") {
          lineas.push({ type: "textBold", text: "Observaciones:" });
          lineas.push({ type: "textWrap", text: observaciones });
          lineas.push({ type: "line" });
        }

        lineas.push({ type: "center", text: "Gracias por su compra :)" });

        return lineas;
      }

      for (const articulo in agrupado) {
        const grupo = agrupado[articulo];

        lineas.push({ type: "section", text: articulo });

        const agrupadoPorColor = {};
        const tallasMap = new Map();

        grupo.forEach((a) => {
          const color = a.colores?.[0]?.name || "Sin color";
          const tallaBase = safeText(a.tallas?.[0]?.name) || "Sin talla";
          const variante = safeText(a.tallas?.[0]?.variantesTallas?.[0]?.name);

          const tallaCompleta = variante
            ? `${tallaBase} (${variante})`
            : tallaBase;

          if (!agrupadoPorColor[color]) agrupadoPorColor[color] = {};
          if (!agrupadoPorColor[color][tallaCompleta]) {
            agrupadoPorColor[color][tallaCompleta] = 0;
          }

          agrupadoPorColor[color][tallaCompleta] += Number(a.cantidad || 0);
          tallasMap.set(tallaCompleta, tallaBase);
        });

        const tallasOrdenadas = Array.from(tallasMap.keys()).sort((a, b) => {
          const baseA = tallasMap.get(a) || a;
          const baseB = tallasMap.get(b) || b;

          const indexA = ordenTallas.indexOf(baseA);
          const indexB = ordenTallas.indexOf(baseB);

          return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
        });

        let totalPiezasArticulo = 0;

        Object.keys(agrupadoPorColor).forEach((color) => {
          lineas.push({ type: "textBold", text: `Color: ${color}` });

          tallasOrdenadas.forEach((talla) => {
            const cantidad = agrupadoPorColor[color][talla] || 0;

            if (cantidad > 0) {
              totalPiezasArticulo += cantidad;
              lineas.push({
                type: "item",
                text: `${talla}: ${cantidad}`,
              });
            }
          });
        });

        lineas.push({
          type: "textBold",
          text: `Piezas artículo: ${totalPiezasArticulo}`,
        });
        lineas.push({ type: "line" });
      }

      if (observaciones) {
        lineas.push({ type: "textBold", text: "Observaciones:" });
        lineas.push({ type: "textWrap", text: observaciones });
        lineas.push({ type: "line" });
      }

      lineas.push({ type: "center", text: "Gracias por su compra" });

      return lineas;
    };

    const lineasTicket = construirLineasTicket();

    const calcularAltura = (lineas) => {
      let altura = 25;

      lineas.forEach((l) => {
        if (l.type === "logo") {
          altura += 18;
        } else if (l.type === "textWrap") {
          const extra = Math.ceil(String(l.text || "").length / 30);
          altura += extra * 4.2;
        } else if (l.type === "title") {
          altura += 6;
        } else if (l.type === "line") {
          altura += 3;
        } else if (l.type === "tableRow") {
          const extra = Math.max(
            1,
            Math.ceil(String(l.descripcion || "").length / 18)
          );
          altura += extra * 4.2;
        } else {
          altura += 4.2;
        }
      });

      return altura + 10;
    };

    const alturaTotal = calcularAltura(lineasTicket);

    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: [80, alturaTotal],
    });

    const pageWidth = 80;
    const marginX = 4;
    const maxWidth = pageWidth - marginX * 2;

    const printWrapped = (text, x, currentY, opts = {}) => {
      const { fontSize = 8, style = "bold", align = "left" } = opts;

      doc.setFont("courier", style);
      doc.setFontSize(fontSize);

      const lines = doc.splitTextToSize(String(text || ""), maxWidth);

      lines.forEach((line) => {
        if (align === "center") {
          doc.text(line, pageWidth / 2, currentY, { align: "center" });
        } else {
          doc.text(line, x, currentY);
        }
        currentY += 4;
      });

      return currentY;
    };

    const dibujarLineas = (lineas, yInicial) => {
      let y = yInicial;

      for (const linea of lineas) {
        switch (linea.type) {
          case "logo": {
            try {
              const img1 = new Image();
              img1.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
              doc.addImage(img1, "PNG", 20, y, 40, 12);
              y += 15;
            } catch (e) {
              y += 2;
            }
            break;
          }

          case "title":
            y = printWrapped(linea.text, marginX, y, {
              fontSize: 11,
              style: "bold",
              align: "center",
            });
            y += 1;
            break;

          case "section":
            y = printWrapped(linea.text, marginX, y, {
              fontSize: 10,
              style: "bold",
            });
            break;

          case "textBold":
            y = printWrapped(linea.text, marginX, y, {
              fontSize: 10,
              style: "bold",
            });
            break;

          case "center":
            y = printWrapped(linea.text, marginX, y, {
              fontSize: 8,
              style: "bold",
              align: "center",
            });
            break;

          case "textWrap":
            y = printWrapped(linea.text, marginX, y, {
              fontSize: 8,
              style: "bold",
            });
            break;

          case "item":
            y = printWrapped(`  ${linea.text}`, marginX, y, {
              fontSize: 8,
              style: "bold",
            });
            break;

          case "line":
            doc.setLineWidth(0.2);
            doc.line(marginX, y, pageWidth - marginX, y);
            y += 3;
            break;

          case "tableHeader": {
            doc.setFont("helvetica", "bold");
            doc.setFontSize(8);
            const xCant = marginX;
            const xDesc = marginX + 12;
            const xPU = pageWidth - marginX - 22;
            const xImp = pageWidth - marginX;
            doc.text("Cant.", xCant, y);
            doc.text("Descripcion", xDesc, y);
            // TK6 — títulos P.U./Importe solo si el ticket sale con precio
            if (mostrarPrecio) {
              doc.text("P.U.", xPU, y, { align: "right" });
              doc.text("Importe", xImp, y, { align: "right" });
            }
            y += 4.2;
            break;
          }

          case "tableRow": {
            doc.setFont("helvetica", "normal");
            doc.setFontSize(8);
            const xCant = marginX;
            const xDesc = marginX + 12;
            const xPU = pageWidth - marginX - 22;
            const xImp = pageWidth - marginX;
            const descMaxWidth = xPU - xDesc - 4;
            const descLines = doc.splitTextToSize(
              String(linea.descripcion || ""),
              descMaxWidth
            );
            doc.text(String(linea.cant), xCant, y);
            doc.text(descLines, xDesc, y);
            doc.text(String(linea.pu), xPU, y, { align: "right" });
            doc.text(String(linea.importe), xImp, y, { align: "right" });
            y += descLines.length * 4.2;
            break;
          }

          default:
            y = printWrapped(linea.text, marginX, y, {
              fontSize: 8,
              style: "bold",
            });
            break;
        }
      }

      return y;
    };

    let y = 6;
    dibujarLineas(lineasTicket, y);

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const printWindow = window.open(pdfUrl);

    printWindow.onload = function () {
      printWindow.focus();
      printWindow.print();
    };
  } catch (err) {
    console.error("Error generando PDFTicket:", err);
    Swal.fire("Error", "No se pudo generar el ticket", "error");
  }
}

function formatMoney(val) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(val);
}


  // (2026-10) editar el número de factura de una venta desde el listado
  async function editarFactura(a) {
    const actual = String(a.numeroFactura || "").trim();
    const { value: nueva, isConfirmed } = await Swal.fire({
      title: `Número de factura · Nota ${a.numero}`,
      input: "text",
      inputValue: ["NA", "NO"].includes(actual.toUpperCase()) ? "" : actual,
      inputPlaceholder: "Número de factura",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      inputValidator: (v) =>
        !String(v || "").trim() ? "Captura el número de factura" : undefined,
    });
    if (!isConfirmed) return;
    const numeroFactura = String(nueva || "").trim();
    const headersAuth = {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    };
    try {
      await axios.patch(`${URL_SURTIDOS}/${a._id}`, { numeroFactura }, headersAuth);
      await axios.post(
        URL_LOGS,
        {
          tipo: "Editar Factura Venta",
          detalle: `Nota ${a.numero}: ${actual || "NA"} -> ${numeroFactura}`,
          user: user.id,
        },
        headersAuth
      );
      setComments((prev) =>
        prev.map((i) => (i._id === a._id ? { ...i, numeroFactura } : i))
      );
      Swal.fire("Listo", "Número de factura actualizado", "success");
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "No se pudo actualizar el número de factura", "error");
    }
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Factura", field: "numeroFactura", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Sucursal", field: "sucursalColaborador", sortable: true },
    { name: "Colaborador", field: "nombreColaborador", sortable: true },
    { name: "Duplicado", field: "duplicado", sortable: true },
    { name: "Pedido Cliente", field: "pedidoCliente", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "SubTotal", field: "subTotal", sortable: true },
    { name: "IVA", field: "iva", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.sucursalColaborador.toLowerCase().includes(search.toLowerCase()) ||
          comment.nombreColaborador.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroFactura.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidoCliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.duplicado.toLowerCase().includes(search.toLowerCase()) ||
          // comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.subTotal.toString().includes(search) ||
          comment.iva.toString().includes(search) ||
          comment.total_general.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
     if (selectedSucursal) {
      computedComments = computedComments.filter((e) =>
        e.sucursalColaborador.includes(selectedSucursal)
      );
    }
    if (selectedUser) {
      computedComments = computedComments.filter((e) =>
        e.idUser.includes(selectedUser)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (selectedImpuestos == "Si") {
      computedComments = computedComments.filter(
        (e) => e.iva > 0
      );
    }
    if (selectedImpuestos == "No") {
      computedComments = computedComments.filter(
        (e) => e.iva == 0
      );
    }
      if (selectedDuplicado) {
      computedComments = computedComments.filter((e) =>
        e.duplicado.includes(selectedDuplicado)
      );
    }
    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "pedidos" &&
      sorting.field != "numero" &&
      sorting.field != "total_general" &&
      sorting.field != "subTotal" &&
      sorting.field != "iva"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "total_general" ||
        sorting.field == "subTotal" ||
        sorting.field == "iva")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "total_general" ||
        sorting.field == "subTotal" ||
        sorting.field == "iva")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedSucursal,
    selectedUser,
    selectedFechaInicio,
    selectedFechaFin,
    selectedImpuestos,
    selectedDuplicado
  ]);

  async function validarSurtido(id){
    await axios
          .patch(
            `${URL_SURTIDOS}/${id}`,
            {
              recibida: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            // toggle();
            Swal.fire("Good job!", "Actualizado con exito", "success");
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.recibida = "Si";
              }
              return i;
            });
            setComments(newComments);
          })
           .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });

  }


// function EditArticulos(idOC) {
//   setArticulosSurtidos([
//     {
//       id: uuidv4(),
//       idArtSur: "",
//       articulos: "",
//       articuloNombre: "",
//       colorFactura: "",
//       colores: "",
//       tallas: "",
//       cantidad: 0,
//     },
//   ]);
//   setIdEdit(idOC);
//   axios
//     .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idOC}`, {
//       headers: {
//         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
//       },
//     })
//     .then((response) => {
//       let allArticulosPedido = response.data;
//       let arrayTabla = allArticulosPedido
//         .map((a) => {
//           return {
//             idArtSur: a._id,
//             articulos: a.articulos[0]._id,
//             articuloNombre: a.articulos[0].codigo,
//             talla: a.tallas[0].name,
//             colores: a.colores[0].name,
//             colorFactura: a.colorFactura
//           };
//         })
//         .filter(function (el) {
//           return el != null;
//         });

//       let dataFinal = Object.values(arrayTabla);
//       setArticulosSurtidos(dataFinal);
//     })
//     .catch((err) => {
//       console.log(err);
//     });
//   toggleEditArticulos();
// }

// const handleChangeInput = (id, event) => {
//   const newArticulosSurtidos = articulosSurtidos.map((i) => 
//     i.idArtSur === id ? { ...i, colorFactura: event.target.value } : i
//   );

//   setArticulosSurtidos(newArticulosSurtidos);
// };
// async function editSurtido(event) {
//   event.preventDefault();
//   setValidaBoton(false);
//   toggleProgreso();

//   const URL_LOGS = `${process.env.REACT_APP_URL_LOGS}`;
//   const token = localStorage.getItem("app_token");

//   try {
//     await Promise.all(
//       articulosSurtidos.map((a) => {
//         const URL_ARTICULOS_SURTIDOS_EDIT = `${process.env.REACT_APP_URL_ARTICULOS_SURTIDOS}/${a.idArtSur}`;
        
//         return axios.patch(
//           URL_ARTICULOS_SURTIDOS_EDIT,
//           { colorFactura: a.colorFactura },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       })
//     );

//     // Si todas las peticiones fueron exitosas, registramos en los logs
//     await axios.post(
//       URL_LOGS,
//       {
//         tipo: "Editar Surtido",
//         detalle: "Editar Surtido",
//         user: user.id,
//       },
//       { headers: { Authorization: `Bearer ${token}` } }
//     );

//     Swal.fire("¡Éxito!", "Surtido editado correctamente", "success");
    
//     setTimeout(() => {
//       window.location.reload();
//     }, 1000);
    
//   } catch (error) {
//     console.error("Error al editar surtido:", error);
//     Swal.fire("Error", "Hubo un problema al editar el surtido", "error");
//   }
// }


  let totalImporteTabla = 0;
  let subTotalTabla = 0;
  let totalIVATabla = 0;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_admin || user.menu_surtidos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {/* <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button> */}
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Facturas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ventas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Sucursal</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedSucursal}
                onChange={(e) => {
                  setSelectedSucursal(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {sucursales
                  .sort((a, b) =>
                    a.name > b.name ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
             <Col md={2}>
                        <Label className="mr-sm-2">Impuestos</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={selectedImpuestos}
                          onChange={(e) => {
                            setSelectedImpuestos(e.target.value);
                            setCurrentPage(1);
                          }}
                        >
                          <option value="">Selecciona</option>
                          <option value="Si">Sí</option>
                          <option value="No">No</option>
                        </Input>
                      </Col>

                       <Col md={2}>
                        <Label className="mr-sm-2">Duplicado</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={selectedDuplicado}
                          onChange={(e) => {
                            setSelectedDuplicado(e.target.value);
                            setCurrentPage(1);
                          }}
                        >
                          <option value="">Selecciona</option>
                          <option value="Si">Sí</option>
                          <option value="No">No</option>
                        </Input>
                      </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                if(a.is_active == "No"){
                  return (
                    <tr style={{ backgroundColor: "#ed8c8c"}}>
                      <td>{a.numero}</td>
                      <td>{a.numeroFactura}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.sucursalColaborador}</td>
                      <td>{a.nombreColaborador}</td>
                      <td>{a.duplicado}</td>
                      <td>{a.pedidoCliente}</td>
                      <td>{a.vendedor}</td>
                      <td>{a.is_active == "Si" ? (
                        new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general)
                          ) : undefined}
                      </td>
                      <td>CANCELADA</td>
                      <td></td>
                      <td></td>
                    </tr>
                  );
                }else{
                  totalImporteTabla = totalImporteTabla + a.total_general;
                  subTotalTabla = subTotalTabla + a.subTotal;
                  totalIVATabla = totalIVATabla + a.iva;
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {a.numeroFactura}{" "}
                        <Button
                          size="sm"
                          color="info"
                          title="Editar número de factura"
                          onClick={() => editarFactura(a)}
                        >
                          <i class="far fa-edit"></i>
                        </Button>
                      </td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.sucursalColaborador}</td>
                      <td>{a.nombreColaborador}</td>
                      <td>{a.duplicado}</td>
                      <td>{a.pedidoCliente}</td>
                      <td>{a.vendedor}</td>
                      <td>{ new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subTotal)}
                      </td>
                      <td>{ new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva)}
                      </td>
                      <td>{ new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general)}
                      </td>
                      <td>
                        {/* <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) =>
                              EditArticulos(a._id)
                            }
                          >
                            <i class="fas fa-cart-plus"></i>
                          </Button> */}
                          <>
                          {a.recibida == "No" ? (
                        <>
                        {/* <Button
                            size="sm"
                            className="btn"
                            color="success"
                            onClick={(e) =>validarSurtido(a._id)}
                          >
                            <i class="far fa-check-circle"></i>
                          </Button> */}
                        </>
                      ) : undefined}
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidoCliente,
                                  a.impuestos,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.totalCantidad,
                                  a.plazo,
                                  a.numeroFactura,
                                  a.descuento,
                                  a.descuento2,
                                  {
                                    empresa: a.empresa,
                                    subCliente: a.subCliente,
                                    telefono: a.telefonoCliente,
                                    direccion: a.direccionCliente,
                                    esVentaDirecta: a.esVentaDirecta,
                                  }
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                            <Button
                              size="sm"
                              className="btn"
                              color="info"
                              onClick={(e) =>
                                PDFTicket(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidoCliente,
                                  a.impuestos,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.totalCantidad,
                                  a.plazo,
                                  a.numeroFactura,
                                  a.descuento,
                                  a.descuento2,
                                  a.nombreColaborador,
                                  a.sucursalColaborador,
                                  a.areaColaborador,
                                  a.numeroColaborador,
                                  a.entregadoCon,
                                  a.esVentaDirecta,
                                  a.alumno,
                                  a.formaPago,
                                  a.vendedor,
                                  a.idPedido
                                )
                              }
                            >
                              {/* <i class="far fa-file-pdf"></i> */}
                              <i class="fa-solid fa-ticket"></i>
                            </Button>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => cancelarNota(a._id)}
                            >
                              <i class="fas fa-ban"></i>
                            </Button>
                            {/* <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) =>
                                Utilidad(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidos,
                                  a.impuestos,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.plazo
                                )
                              }
                            >
                            <i class="fas fa-chart-line"></i>
                            </Button> */}
                            {/* {a.recibida == "No" ? (
                              <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) => recibida(a._id)}
                            >
                              <i class="far fa-check-circle"></i>
                            </Button>
  
                            ):undefined} */}
                          </>
                      </td>
                    </tr>
                  );
                }

              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotalTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIVATabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalImporteTabla)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />


      {/* <Modal
        size="xl"
        isOpen={modalEditArticulos}
        toggle={toggleEditArticulos}
      >
        <ModalHeader toggle={toggleEditArticulos}>
          <h4>Editar Articulos Surtido</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={editSurtido}
          >
            <Table>
              <thead>
                <tr>
                  <th>Articulo</th>
                  <th>Talla</th>
                  <th>Color Factura</th>
                </tr>
              </thead>

              <tbody>
                {articulosSurtidos 
                .sort((a, b) => {
                  const colorCompare = a.colores.localeCompare(b.colores);
                  if (colorCompare !== 0) return colorCompare;
                  return a.talla.localeCompare(b.talla);
                })
                .map((ao) => (
                  <tr key={ao.id}>
                    <td>{ao.articuloNombre}</td>
                    <td>{ao.talla}</td>
                  <td>
                    <Input
                      type="text"
                      name="color"
                      id="color"
                      value={ao.colorFactura}
                      key={ao.id}
                      onChange={(e) =>
                        handleChangeInput(ao.idArtSur, e)
                      }
                    />
                  </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal> */}


            <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
              <ModalHeader toggle={toggleProgreso}>
                <h4>Progreso</h4>
              </ModalHeader>
              <ModalBody>
                <h4>
                  {" "}
                  Este proceso puede tardar varios minutos.
                  <br />
                  Por favor no cierre ni refresque su navegador.
                </h4>
                <br />
                <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                </div>
              </ModalBody>
            </Modal>
      {loader}
    </>
  );
}

export default ListadoVentas;
